import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import SidebarNavItem from "./SidebarNavItem";
import styles from "./Sidebar.module.css";

const SidebarDropdown = ({ section, isCollapsed, onNavigate }) => {
  const location = useLocation();
  const Icon = section.icon || (section.items && section.items[0]?.icon);

  // Check if any child item matches current location
  const isAnyChildActive = (section.items || []).some((item) => {
    if (!item.path) return false;
    const currentFull = location.pathname + location.search;
    if (item.path === currentFull) return true;
    if (item.path === location.pathname && !item.path.includes("?")) {
      return true;
    }
    return false;
  });

  const [isOpen, setIsOpen] = useState(isAnyChildActive);

  // Auto-expand if user navigates to a child route
  useEffect(() => {
    if (isAnyChildActive) {
      setIsOpen(true);
    }
  }, [isAnyChildActive]);

  return (
    <div className={styles.dropdownGroup}>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className={`${styles.dropdownTrigger} ${
          isAnyChildActive ? styles.dropdownTriggerActive : ""
        } ${isCollapsed ? styles.navItemCollapsed : ""}`}
        title={isCollapsed ? section.category : undefined}
      >
        {Icon && <Icon className={styles.itemIcon} />}
        {!isCollapsed && (
          <>
            <span className={styles.itemLabel}>{section.category}</span>
            <ChevronDown
              size={16}
              className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""}`}
            />
          </>
        )}
      </button>

      {isOpen && !isCollapsed && (
        <div className={styles.dropdownContent}>
          {section.items.map((item) => (
            <SidebarNavItem
              key={item.path}
              item={item}
              isCollapsed={isCollapsed}
              onNavigate={onNavigate}
              isSubItem={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarDropdown;
